import url_join from "url-join";

export const routeTo = (...args) => {
  const definedArgs = args.filter((x) => x !== undefined);
  const stringifiedArgs = definedArgs.map((item) => item.toString());
  return url_join(...stringifiedArgs);
};
